var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstitute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16.003,
    viewBox: "0 0 16 16.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#8e8e8e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.264 -288.798)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.217.267a.526.526,0,0,0-.161.04L.591,3.507A.534.534,0,0,0,.264,4V6.133A.533.533,0,0,0,.8,6.664H15.733a.533.533,0,0,0,.531-.531V4a.534.534,0,0,0-.323-.493L8.476.307a.532.532,0,0,0-.259-.04Zm.049,3.2A.533.533,0,1,1,7.733,4,.533.533,0,0,1,8.266,3.465Zm-6.4,4.267V12H4V7.732Zm5.333,0V12H9.333V7.732Zm5.333,0V12h2.133V7.732ZM1.812,13.066a.53.53,0,0,0-.323.153L.421,14.287a.534.534,0,0,0-.157.378v1.067a.533.533,0,0,0,.535.535H15.733a.533.533,0,0,0,.531-.535V14.657a.534.534,0,0,0-.157-.382L15.04,13.219a.533.533,0,0,0-.374-.153H1.812Z",
    transform: "translate(0 288.533)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstitute);
export default __webpack_public_path__ + "static/media/institute.65b727f4aa3114d6ec82ea91e8914426.svg";
export { ForwardRef as ReactComponent };